<template>
  <div
    class="d-flex justify-center align-center pa-8"
    :style="formActionsStyles"
  >
    <TextButton :label="t$('.cancel')" class="mr-2" @click="emitCancel" />
    <Button
      @click="emitSave"
      :disabled="disableSaveButton"
      :btn-label="t$('.save')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import TextButton from "components/UI/TextButton.vue"
import Button from "components/UI/Button.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import vuetify from "initializers/vuetify"

export default defineComponent({
  name: "FormActions",
  components: { Button, TextButton },
  props: {
    disableSaveButton: { type: Boolean, required: false, default: false },
  },
  computed: {
    formActionsStyles() {
      return {
        backgroundColor: `${vuetify.framework.theme.themes.light.lightGrey} !important`,
        borderRadius: "4px",
        height: "100%",
      }
    },
  },
  methods: {
    emitCancel() {
      this.$emit("cancel")
    },
    emitSave() {
      this.$emit("save")
    },
  },
  setup() {
    const { t$ } = useTranslate("common")

    return {
      t$,
    }
  },
})
</script>
